import { MdsIcon, MdsIconKind } from "@/design-system/components/icon";
import { generateRecentDateString } from "@/domains/date/date";
import { renderArrayWithAnds } from "@/domains/string/renderArrayWithAnds";
import { IContact } from "@/store/contacts/types";
import { INoteObservable } from "@/store/note/types";
import { TemplateObservable } from "@/store/templates/TemplateObservable";
import { MemCommonMentionKind, ExtractedNoteMention } from "@mem-labs/common-editor";
import styled from "@emotion/styled";

export const getNoteMetadata = ({
  authorNames,
  note,
  updateOnly,
}: {
  authorNames?: string;
  note: INoteObservable | TemplateObservable;
  updateOnly?: boolean;
}) => {
  if (note.isSuggestionActive) {
    return (
      <HasSuggestedEditsContainer>
        <Icon kind={MdsIconKind.SparkleOutline} />
        <span>Suggested edits by Mem</span>
      </HasSuggestedEditsContainer>
    );
  }
  return `${generateRecentDateString(note.locallyCreatedAt)}${
    updateOnly ? "" : ` | ${generateRecentDateString(note.modifiedAt)}`
  } — ${authorNames ?? getAuthorNames({ note })}`;
};

export const getContactDisplayNames = ({
  contacts,
}: {
  contacts: Pick<IContact, "profileDisplayName">[];
}) => {
  return renderArrayWithAnds(contacts.map(e => e.profileDisplayName));
};

export const getAuthorNames = ({ note }: { note: INoteObservable | TemplateObservable }) => {
  return getContactDisplayNames({ contacts: note.authors });
};

export const getMentionedNoteIds = (mentions: ExtractedNoteMention[]) => {
  return mentions
    .filter(mention => mention.kind === MemCommonMentionKind.Note)
    .map(mention => mention.id);
};

const HasSuggestedEditsContainer = styled.div`
  color: ${({ theme }) => theme.colors.mblue.x500};
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.xs};
`;

const Icon = styled(MdsIcon)`
  color: ${({ theme }) => theme.colors.mblue.x500};
`;
